module.exports = __webpack_public_path__ + "fonts/AlibabaPuHuiTi-3-65-Medium.c8015ba2.ttf";